import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPagination } from 'src/app/models/Pagination';
import { IProductType } from 'src/app/models/Summary';

export interface ICustomFilter {
    airportCode: string[];
    product: IProductType;
    startDate: Date | null;
}

interface DriverSummaryState {
    driverSummary: any;
    hasfilterApplied: boolean;
    search: string;
    customFilter: ICustomFilter;
    paginationResponse: IPagination;
    bookingsCount: number;
}

const initialState: DriverSummaryState = {
    driverSummary: [],
    hasfilterApplied: false,
    search: '',
    customFilter: {
        airportCode: [],
        product: 'ALL',
        startDate: new Date(),
    },
    paginationResponse: {
        pageNumber: 1,
        pageSize: 20,
    },
    bookingsCount: 0,
};

export const driverSummarySlice = createSlice({
    name: 'driverSummary',
    initialState,
    reducers: {
        setSearch: (state, action: PayloadAction<string | null>) => {
            state.search = action.payload;
        },
        setStartDate: (state, action: PayloadAction<Date | null>) => {
            state.customFilter.startDate = action.payload;
        },
        setProduct: (state, action: PayloadAction<IProductType>) => {
            state.customFilter.product = action.payload;
        },
        setAirportCode: (state, action: PayloadAction<string[]>) => {
            state.customFilter.airportCode = action.payload;
        },
        applyFilter: (state) => {
            state.hasfilterApplied = true;
        },
        clearFilter: (state) => {
            state.search = '';
            state.hasfilterApplied = false;
            state.customFilter.airportCode = [];
            state.customFilter.product = 'ALL';
            state.customFilter.startDate = new Date();
        },
    },
});

export const { setSearch, setAirportCode, setProduct, setStartDate, applyFilter, clearFilter } =
    driverSummarySlice.actions;
export default driverSummarySlice.reducer;
